import axios from "axios";

import api from "../api";
import { ConfirmAdminUploadDto, GenerateAdminUploadUrlDto } from "../dto/admin-attachments";
import { ConfirmAdminUploadResponse, GenerateAdminUploadUrlResponse } from "../response/admin-attachments";

export const ADMIN_ATTACHMENTS_ENDPOINTS = {
  GENERATE_UPLOAD_URL: "/v1/admin/attachments/generate-upload-url",
  CONFIRM_UPLOAD: "/v1/admin/attachments/confirm-upload",
};

interface AdminAttachmentsRequestOptions {
  signal?: AbortSignal;
}

export const AdminAttachments = {
  generateUploadUrl: async (
    data: GenerateAdminUploadUrlDto,
    { signal }: AdminAttachmentsRequestOptions = {},
  ): Promise<GenerateAdminUploadUrlResponse> => {
    const response = await api.post(ADMIN_ATTACHMENTS_ENDPOINTS.GENERATE_UPLOAD_URL, data, { signal });
    return response.data;
  },

  confirmUpload: async (
    data: ConfirmAdminUploadDto,
    { signal }: AdminAttachmentsRequestOptions = {},
  ): Promise<ConfirmAdminUploadResponse> => {
    const response = await api.post(ADMIN_ATTACHMENTS_ENDPOINTS.CONFIRM_UPLOAD, data, { signal });
    return response.data;
  },
};

interface UploadFileToStorageParams {
  signal?: AbortSignal;
  onProgress?: (progress: number) => void;
}

/**
 * PUTs directly to a presigned storage URL. Uses a bare axios instance (not `api`) since the
 * presigned URL must not receive the app's Authorization header or baseURL.
 */
export const uploadFileToStorage = async (
  uploadUrl: string,
  file: File,
  { signal, onProgress }: UploadFileToStorageParams = {},
): Promise<void> => {
  await axios.put(uploadUrl, file, {
    signal,
    headers: { "Content-Type": file.type || "application/octet-stream" },
    onUploadProgress: (event) => {
      if (!onProgress || !event.total) return;
      onProgress(Math.round((event.loaded / event.total) * 100));
    },
  });
};
